function sameTitle(left, right) {
  return String(left || '').trim().toLowerCase() === String(right || '').trim().toLowerCase();
}

export function volumeFor(series, book) {
  const volume = Number(series?.volumes?.[book?.id]);
  return Number.isInteger(volume) && volume > 0 ? volume : null;
}

export function booksInSeries(series, projects) {
  const byId = new Map((projects || []).map((project) => [project.id, project]));
  const ids = new Set(series?.bookIds || []);
  for (const project of projects || []) {
    if (project?.seriesId && project.seriesId === series?.id) ids.add(project.id);
  }
  return [...ids]
    .map((id) => byId.get(id))
    .filter(Boolean)
    .sort((a, b) => {
      const av = volumeFor(series, a);
      const bv = volumeFor(series, b);
      if (av && bv && av !== bv) return av - bv;
      if (av && !bv) return -1;
      if (!av && bv) return 1;
      return String(a.title || '').localeCompare(String(b.title || ''));
    });
}

export function looseProjects(projects, seriesList) {
  const placed = new Set();
  for (const series of seriesList || []) {
    for (const book of booksInSeries(series, projects)) placed.add(book.id);
  }
  return (projects || []).filter((project) => !placed.has(project.id));
}

export function bookNavTitle(series, book) {
  const volume = volumeFor(series, book);
  const repeatsSeries = sameTitle(book?.title, series?.title);
  if (volume && repeatsSeries) return `Vol ${volume}`;
  if (volume) return `${book.title}, Vol ${volume}`;
  if (repeatsSeries && book?.subtitle) return book.subtitle;
  return book?.title || book?.id || '';
}

export function bookNavSubtitle(series, book) {
  const title = bookNavTitle(series, book);
  const subtitle = String(book?.subtitle || '').trim();
  if (subtitle && subtitle !== title) return subtitle;
  if (!subtitle && book?.bibleVersion) return `Bible v${book.bibleVersion}`;
  return '';
}
